import type { Direction } from "../lib/scoring";
import snapshot from "./generated/site-content.json" with { type: "json" };
import {
  soulCheckContentSchema,
  type DirectionOutcome,
} from "./schemas";

/**
 * The Soul Check wording is authored in Sanity. The structure is not: the
 * tuple schemas keep it at exactly four questions whose answer codes match
 * `intake-schema.ts`, because those codes drive `computeDirection` here and
 * the recomputation in the Netlify Function.
 *
 * Rewording a question is an editorial change. Changing what a question
 * *means* is a product change and should bump `QUESTIONNAIRE_VERSION`.
 */
const soulCheck = soulCheckContentSchema.parse(snapshot.soulCheck);

export const soulCheckIntro = soulCheck.intro;
export const soulCheckQuestions = soulCheck.questions;
export const directionOutcomeList = soulCheck.outcomes;
export const soulCheckMethodCopy = soulCheck.methodCopy;

/**
 * The sentence echoed back for a given answer. Keyed by the semantic answer
 * codes `computeDirection` reports, so scoring stays free of prose.
 */
export const answerExplanations: Readonly<Record<string, string>> =
  Object.fromEntries(
    soulCheck.answerExplanations.map(({ id, text }) => [id, text]),
  );

export const directionOutcomes: Readonly<Record<Direction, DirectionOutcome>> =
  Object.fromEntries(
    directionOutcomeList.map((outcome) => [outcome.direction, outcome]),
  ) as Record<Direction, DirectionOutcome>;
